import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {GetQuotes as GetQuotesQuery, GetQuotesVariables} from 'nutshell-graphql-types';

import GET_QUOTES from '../queries/get-quotes.graphql';

export const useGetQuotes = (leadId: string, skip?: boolean) => {
    const {
        data,
        loading: isLoading,
        networkStatus,
        error,
        refetch,
    } = useQuery<GetQuotesQuery, GetQuotesVariables>(GET_QUOTES, {
        variables: {leadId: leadId},
        skip,
        fetchPolicy: 'cache-and-network',
    });

    const quotes = data ? data.quotes : null;

    const isFirstLoading = isFirstLoad(networkStatus);

    return {
        quotes: quotes ? quotes : [],
        isLoading,
        isFirstLoad: isFirstLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
